module.exports = __webpack_public_path__ + "static/media/no-plan.e2cd327d.png";